import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import CustomDrawer from '../CustomDrawer';

const ResponsiveModal = ({
  open,
  onClose,
  title,
  footer,
  children,
  drawerProps = {},
  modalProps = {},
  style = {},
  bodyStyle = {},
  headerStyle = {},
  extra,
  ...props
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const modalStyles = { header: headerStyle, ...modalProps.styles };
  const drawerStyles = { header: headerStyle, ...drawerProps.styles };

  let drawerFooter = footer;
  if (isMobile && footer && (Array.isArray(footer) || React.isValidElement(footer))) {
    const footerItems = Array.isArray(footer) ? footer : [footer];
    drawerFooter = (
      <div style={{ display: 'flex', gap: 12, width: '100%' }}>
        {footerItems.map((child, idx) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              style: { ...child.props.style, flex: 1 },
              key: child.key || idx
            });
          }
          return child;
        })}
      </div>
    );
  }

  if (isMobile) {
    return (
      <CustomDrawer
        open={open}
        onClose={onClose}
        title={title}
        footer={drawerFooter}
        extra={extra}
        {...props}
        {...drawerProps}
        style={style}
        bodyStyle={bodyStyle}
        headerStyle={headerStyle}
        styles={drawerStyles}
      >
        {children}
      </CustomDrawer>
    );
  }

  const modalTitle = extra ? (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingRight: '36px' }}>
      <span>{title}</span>
      <div style={{ fontWeight: 'normal', display: 'flex', alignItems: 'center' }}>{extra}</div>
    </div>
  ) : (
    title
  );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={modalTitle}
      footer={footer}
      bodyStyle={bodyStyle}
      style={style}
      styles={modalStyles}
      {...props}
      {...modalProps}
    >
      {children}
    </Modal>
  );
};

export default ResponsiveModal;
